<template>
    <div class="wl-page">
        <div class="header-fixed">
            <NavLayout/>
        </div>
        <main class="main-padding">
            <router-view></router-view>
        </main>
        <FooterLayout/>

    </div>
</template>
<script>
import NavLayout from './NavLayout'
import FooterLayout from './FooterLayout'
import { useRoute } from 'vue-router'
import { watch, nextTick } from 'vue'

export default {
  name: 'App',
  components: {
    NavLayout,
    FooterLayout
  },
  setup() {
    const route = useRoute()

    const toggleFloatingEstimator = () => {
      nextTick(() => {
        const el = document.getElementById('widget-floatingEstimator-mount')
        if (!el) return

        // Show the floating estimator on all main layout pages
        el.style.display = ''
      })
    }

    watch(() => route.path, toggleFloatingEstimator, { immediate: true })

    return {}
  }
}
</script>